export default __webpack_public_path__ + "static/media/map.23161ce3.svg";